import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { ESubProject } from '@enums';

import { EmptyAvatar } from '@common/components/EmptyAvatar';
import { PlayButton } from '@common/components/PlayButton';
import { Stores } from '@common/components/Stores';
import { AppStat } from '@common/utils/AppStat';

import { player } from '@modules';

import { ISharePageProps } from './types';

import * as s from './SharePage.scss';

export class SharePage extends React.Component<ISharePageProps> {

	static defaultProps: Partial<ISharePageProps> = {
		gradientStart: -335,
		isCirclePicture: false,
	};

	componentDidMount(): void {
		const { audioUrl } = this.props;

		if (audioUrl) {
			player.setUrl(audioUrl);
		}
	}

	componentDidUpdate(prevProps: Readonly<ISharePageProps>, prevState: Readonly<{}>): void {
		if (!prevProps.audioUrl && this.props.audioUrl) {
			player.setUrl(this.props.audioUrl);
		}
	}

	onPlayClick = () => {
		AppStat.log.share.play();
	};

	render() {
		const {
			gradientColor,
			gradientStart,
			entityName,
			pictureUrl,
			pictureContent,
			isHidePicture,
			isCirclePicture,
			title,
			description,
			audioUrl,
			isHidePlay,
			isMobileVerticalStoreIcons,
		} = this.props;
		const { copyright } = getConfig();
		const isPlayAvailable = !isHidePlay && !!audioUrl;

		return (
			<div className={s.block}>
				<div className={s.wrapper}>
					<div className={s.content}>
						<div className={s.logo}/>

						<div className={s.entity}>
							<div className={s.entityName}>{entityName}</div>

							<div className={s.pictureWrapper}>
								<div className={s.pictureGradient} style={{ background: `radial-gradient(50% 50% at 50% 50%, ${gradientColor} ${gradientStart}%, rgba(21, 21, 21, 0) 100%)` }} />

								{!isHidePicture && (
									pictureUrl
										? (
											<div
												className={cn(s.picture, { [s.pictureCircle]: isCirclePicture })}
												style={{ backgroundImage: `url("${pictureUrl}")` }}
											/>
										)
										: (
											<EmptyAvatar
												title={title}
												isCircle={isCirclePicture}
											/>
										)
								)}

								{pictureContent && (
									<div className={s.pictureContent}>{pictureContent}</div>
								)}
							</div>

							<div className={s.title}>{title}</div>
							<div className={s.description}>{description}</div>

							{isPlayAvailable && <PlayButton onPlay={this.onPlayClick} className={s.play}/>}
						</div>

						<Stores
							isIconFilled={false}
							className={s.stores}
							from={ESubProject.SHARE}
							isVertical={isMobileVerticalStoreIcons}
						/>
					</div>

					<div className={s.copyright}>{copyright}</div>
				</div>
			</div>
		);
	}

}
